import { NotificationsPresetEnum } from '../enums/notifications-preset.enum';

import { RentalAgreementsNotificationOptions } from './rental-agreements-notification-options';
import { VehicleInsurancesNotificationOptions } from './vehicle-insurances-notification-options';
import { VehicleRoadTaxesNotificationOptions } from './vehicle-road-taxes-notification-options';
import { VehicleRoadWorthyChecksNotificationOptions } from './vehicle-road-worthy-checks-notification-options';

/**
 * Notification options
 * @description This class represents the user's notification options for the channel.
 */
export class NotificationOptions {
	/**
	 * Flag indicating if notifications are enabled
	 * @description If false, no notifications will be sent regardless of other settings.
	 */
	enabled!: boolean;

	/**
	 * Notification preset
	 * @description Determines what notifications options are used for each module.
	 */
	preset!: NotificationsPresetEnum;

	/**
	 * Notification options for Rental Agreements module to be used when the preset is set to 'custom'
	 */
	rentalAgreements?: RentalAgreementsNotificationOptions;

	/**
	 * Notification options for Vehicle Insurances module to be used when the preset is set to 'custom'
	 */
	vehicleInsurances?: VehicleInsurancesNotificationOptions;

	/**
	 * Notification options for Vehicle Road Taxes module to be used when the preset is set to 'custom'
	 */
	vehicleRoadTaxes?: VehicleRoadTaxesNotificationOptions;

	/**
	 * Notification options for Vehicle Road Worthy Checks module to be used when the preset is set to 'custom'
	 */
	vehicleRoadWorthyChecks?: VehicleRoadWorthyChecksNotificationOptions;
}
